import { Grid, Table, TableBody, TableCell } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import { TableRow } from '../../common/Table';

type SummaryProps = {
  summary: string,
  asa_compliant?: boolean,
  opusProps?: {
    opus_title: string
    opus_description: string
    opus_clip_genre: string
    opus_hashtags: string[]
  }
}
export const PanelVideoSummary = ({ summary, opusProps, asa_compliant = true }: SummaryProps) => {
  return <Grid container spacing={1}>
    <Grid item xs={12} justifyContent={'center'}>
      <Box sx={{
        // minHeight: '400px',
        p: 4
      }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell component="th"
                         sx={{ fontWeight: 'bold', width: '200px' }}>Summary</TableCell>
              <TableCell>{summary || 'Summary not available.'}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell component="th" sx={{ fontWeight: 'bold' }}>ASA compliant</TableCell>
                <TableCell>{ asa_compliant ? 'Yes' : 'No'}</TableCell>
              </TableRow>
            {opusProps && <>
              {opusProps.opus_title && (
                <TableRow>
                  <TableCell component="th" sx={{ fontWeight: 'bold', width: '200px' }}>Alternative title</TableCell>
                  <TableCell>{opusProps.opus_title}</TableCell>
                </TableRow>
              )}
              {opusProps.opus_description && (
                <TableRow>
                  <TableCell component="th" sx={{ fontWeight: 'bold' }}>Description</TableCell>
                  <TableCell>{opusProps.opus_description}</TableCell>
                </TableRow>
              )}
              {opusProps.opus_clip_genre && (
                <TableRow>
                  <TableCell component="th" sx={{ fontWeight: 'bold' }}>Category</TableCell>
                  <TableCell>{opusProps.opus_clip_genre}</TableCell>
                </TableRow>
              )}
              {(opusProps.opus_hashtags || []).length > 0 && (
                <TableRow>
                  <TableCell component="th" sx={{ fontWeight: 'bold' }}>Tags</TableCell>
                  <TableCell>{opusProps.opus_hashtags.join(', ')}</TableCell>
                </TableRow>
              )}
            </>}

          </TableBody>
        </Table>
      </Box>
    </Grid>;
  </Grid>;
};